// Nav type
export type navLinkType = {
  label: string;
  url: string;
};

// Nav
const navLinks = [
  {
    label: 'about',
    url: '#about-me-section',
  },
  {
    label: 'education',
    url: '#education-section',
  },
  {
    label: 'experience',
    url: '#experience-section',
  },
  {
    label: 'skills',
    url: '#skills-section',
  },
  {
    label: 'projects',
    url: '#works',
  },
  {
    label: 'community',
    url: '#community-section',
  },
  {
    label: 'contact',
    url: '#contact-section',
  },
];
const navbarLinks = [
  {
    label: 'home',
    url: '#hero',
  },
  ...navLinks,
];

const socialLinks = [
  {
    label: 'LinkedIn',
    url: 'https://linkedin.com/in/nhiyngo0',
  },
  {
    label: 'GitHub',
    url: 'https://github.com/nhipixel',
  },
  {
    label: 'Email',
    url: 'mailto:nhiyngo0@gmail.com',
  },
];

const resourceLinks = [
  {
    label: 'Resume',
    url: 'https://drive.google.com/file/d/1fHKgXVwb-4VHEMEO9ea0DifJBe8EfbOg/view?usp=sharing',
  },
  {
    label: 'Portfolio',
    url: '#',
  },
];

const heroText =
  'A passionate software engineer and AI enthusiast, crafting innovative solutions with cutting-edge technologies.';

const locationPlace = `43°46'16.0"N 79°30'30.0"W`;
const locationCountry = 'Toronto, ON, Canada';

// cal.com
const dataCalNamespace = '30min';
const dataCalLink = 'nhiyngo/30min';
const dataCalConfig =
  '{"layout":"month_view", "theme": "dark", "brand": "#8C8C73"}';

export {
  socialLinks,
  resourceLinks,
  heroText,
  locationPlace,
  locationCountry,
  navLinks,
  navbarLinks,
  dataCalNamespace,
  dataCalLink,
  dataCalConfig,
};